import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { sessionsApi } from '../lib/api';

export default function Sessions() {
  const { data: sessions, isLoading } = useQuery({
    queryKey: ['sessions'],
    queryFn: sessionsApi.list,
  });

  const getStatusBadge = (status: string) => {
    const styles: Record<string, string> = {
      completed: 'bg-green-500 bg-opacity-20 text-green-500',
      in_progress: 'bg-yellow-500 bg-opacity-20 text-yellow-500',
      paused: 'bg-gray-500 bg-opacity-20 text-gray-500',
      cancelled: 'bg-red-500 bg-opacity-20 text-red-500',
    };
    const labels: Record<string, string> = {
      completed: '完了',
      in_progress: '進行中',
      paused: '一時停止',
      cancelled: 'キャンセル',
    };
    return (
      <span className={`px-2 py-1 rounded text-xs ${styles[status] || styles.cancelled}`}>
        {labels[status] || status}
      </span>
    );
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-theme-primary">セッション一覧</h1>
        <Link
          to="/"
          className="px-4 py-2 bg-accent text-navy-900 font-bold rounded-lg hover:opacity-90 transition-opacity"
        >
          + 新しいセッション
        </Link>
      </div>

      <div className="bg-theme-card rounded-xl border border-theme overflow-hidden transition-colors duration-300">
        {isLoading ? (
          <div className="p-8 text-center text-theme-secondary">読み込み中...</div>
        ) : sessions && sessions.length > 0 ? (
          <table className="w-full">
            <thead className="bg-theme-hover">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-theme-secondary">アイデア</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-theme-secondary">ステータス</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-theme-secondary">進捗</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-theme-secondary">作成日</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-theme-secondary"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-theme">
              {sessions.map(session => (
                <tr key={session.id} className="hover:bg-theme-hover transition-colors">
                  <td className="px-4 py-4">
                    <Link to={`/sessions/${session.id}`} className="text-theme-primary hover:text-accent">
                      {session.initialIdea?.slice(0, 50) || '(アイデア未入力)'}
                      {(session.initialIdea?.length || 0) > 50 && '...'}
                    </Link>
                  </td>
                  <td className="px-4 py-4">
                    {getStatusBadge(session.status)}
                  </td>
                  <td className="px-4 py-4 text-theme-secondary">
                    {session.answeredQuestions}/{session.totalQuestions}
                  </td>
                  <td className="px-4 py-4 text-theme-secondary">
                    {new Date(session.createdAt).toLocaleDateString('ja-JP')}
                  </td>
                  <td className="px-4 py-4">
                    <Link
                      to={`/sessions/${session.id}`}
                      className="text-accent hover:underline text-sm"
                    >
                      詳細 →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-8 text-center text-theme-secondary">
            <p>まだセッションがありません</p>
            <Link to="/" className="text-accent hover:underline mt-2 inline-block">
              Jarvisと対話を始める →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
